import React, { useEffect, useMemo, useState } from "react";
import { useViewport } from "components/general/useViewPort";
import MirsTable from "components/general/table/Table";
import {
  ColumnMedalEvent,
  ColumnMedalEventWithCompetitor,
  ColumnMedal,
  ColumnMedalParticipant,
  ColumnDisciplineMobile,
  ColumnMedalDiscipline,
} from "components/common/schedule/TableColumns";
import { useUrlFriendlyToParameters, useNavigateTo } from "helpers/urlFriendly";
import { getLevelRSC, getLongEventRSC } from "helpers/rsc";

const getConfiguration = ({ breakPoint, eventorder, isAlphabeticalSort = true }) => {
  const isMobile = breakPoint === "sm" || breakPoint === "xs";
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false,
  };
  configuration.sortBy = [{ id: 'Competitor', desc: false }];
  switch (eventorder) {
    case "Event":
      configuration.sortBy = [{ id: "Event", desc: false }];
      configuration.disableSort = true;
      break;
    case "NOC":
      configuration.sortBy = [{ id: 'Discipline', desc: false }, { id: 'Event', desc: false }, { id: 'Medal', desc: false },{ id: 'Competitor', desc: false }];
      break;
  }
  configuration.columns = isMobile ? TableColumnsSM() : TableColumns({ isAlphabeticalSort });
  return configuration;
};

const NocMedallistsTable = ({ data, eventorder }) => {
  const { breakPoint } = useViewport();
  const [isAlphabeticalSort, setIsAlphabeticalSort] = useState(true)
  const config = useMemo(() => getConfiguration({ breakPoint, eventorder, isAlphabeticalSort }), [breakPoint, isAlphabeticalSort]);
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, "results"); 
  useEffect(() => {
    let isAlphabetical = !(data?.some(item => item?.discipline?.descriptionOrder && item?.discipline?.descriptionOrder !== 0));
    setIsAlphabeticalSort(isAlphabetical);
  }, [data]);
  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters();
  let paramsURL = { ...params };

  const handleClick = (props) => {
    const rsc = props?.eventUnit?.code;
    if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
      paramsURL["mirs_event_rsc"] = rsc;
      paramsURL["mirs_rsc"] = undefined;
    } else {
      //Phase or unit
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc);
      paramsURL["mirs_rsc"] = rsc;
    }
    setParamsUrl(paramsURL);
  };

  return (
    <MirsTable
      className="table-schedule"
      data={data}
      columns={config.columns}
      keyRow="participant-code"
      initialSortBy={config.sortBy}
      rowOnClick={true}
      rowClickHandler={handleClick}
      id={`mirs-table-medallists`}
      showLoading={false}
    // showPagination={true}
    // pageSizeCustom={10}
    />
  );
};

export default NocMedallistsTable;

function TableColumns({ isAlphabeticalSort = true }) {
  return [
    ColumnMedalParticipant({ disableSort: false }),
    ColumnMedalDiscipline({ label: "HeaderSport", disableSort: false, showDesc: true, isAlphabeticalSort }),
    ColumnMedalEvent({ disableSort: true }),
    ColumnMedal({}),
    //ColumnDate(globalProps, { disableSort: false })
  ];
}

function TableColumnsSM() {
  return [
    ColumnMedalEventWithCompetitor({}),
    ColumnDisciplineMobile({ showDesc: true }),
    ColumnMedal({}),
  ];
}
